import React from 'react';
import {
  Paper,
  Grid,
  Typography,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import FlagIcon from '@mui/icons-material/Flag';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const PaymentMethod = ({
  paymentMethod,
  isPrimary,
  removePaymentMethod,
  setPrimary,
}) => {
  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CreditCardIcon fontSize='large' />
            <Box>
              <Typography variant='body1'>
                Card x{paymentMethod.card.last4}
              </Typography>
              <Typography variant='body2' color='textSecondary'>
                Expires: {paymentMethod.card.exp_month}/
                {paymentMethod.card.exp_year}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={2}>
          {isPrimary && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FlagIcon color='primary' />
              <Typography>Primary</Typography>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            {!isPrimary && (
              <Button
                variant='outlined'
                onClick={setPrimary}
                startIcon={<StarBorderIcon />}
              >
                Set Primary
              </Button>
            )}
            <IconButton
              variant='outlined'
              color='error'
              onClick={removePaymentMethod}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PaymentMethod;
